/**
 * App - 主入口
 * 初始化所有组件和 Lucide 图标
 */
function initLucideIcons() {
  if (typeof lucide !== 'undefined') {
    lucide.createIcons();
  } else {
    setTimeout(initLucideIcons, 200);
  }
}

document.addEventListener('DOMContentLoaded', function () {
  console.log('GLOWRIUM HTML version initialized');

  // Initialize all components
  MproProductGallery.init();
  FAQSection.init();
  ReviewSection.init();
  FloatingWidgets.init();
  SpectrumScroll.init();

  // Initialize Lucide icons
  initLucideIcons();

  // Desktop Navigation Menu: close dropdowns on outside click
  document.addEventListener('click', function (e) {
    var navItems = document.querySelectorAll('.nav-menu-item');
    var clickedInside = false;

    navItems.forEach(function (item) {
      if (item.contains(e.target)) {
        clickedInside = true;
      }
    });

    if (!clickedInside) {
      navItems.forEach(function (item) {
        item.classList.remove('active');
      });
    }
  });

  // Toggle active class on nav items for mobile-friendly tap
  var navMenuItems = document.querySelectorAll('.nav-menu-item');
  navMenuItems.forEach(function (item) {
    item.addEventListener('click', function (e) {
      // Don't interfere with link clicks
      if (e.target.tagName === 'A') return;

      var isActive = item.classList.contains('active');
      // Close all
      navMenuItems.forEach(function (i) { i.classList.remove('active'); });
      // Toggle current
      if (!isActive) {
        item.classList.add('active');
      }
    });
  });

  // Download button hover effect
  var btnDownload = document.getElementById('btnDownload');
  if (btnDownload) {
    btnDownload.addEventListener('mouseenter', function () {
      btnDownload.style.backgroundColor = '#6a82c4';
    });
    btnDownload.addEventListener('mouseleave', function () {
      btnDownload.style.backgroundColor = '#8097d3';
    });
  }
});
